import { completeFileUpload, requestFileUploadPresign } from '@/services/return/returnWorkScan/apis'
import { FileUploadResourceType } from '@/services/return/returnWorkScan/types'
import { MESSAGES } from './constants'
import { scanNotice } from '@/components/pbo/notice'

const randomSuffix = () => Math.random().toString(36).slice(2, 8)

/**
 * S3 PUT — `@/utils/request` 를 쓰지 않는다. 인터셉터가 Authorization 을 붙이면 S3 서명이 깨진다(3장 4절).
 * 순수 `fetch` 로 `signedHeaders` 를 그대로 얹는다.
 */
const uploadToS3 = async (uploadUrl: string, signedHeaders: Record<string, string[]>, blob: Blob) => {
  const headers = new Headers()
  Object.entries(signedHeaders).forEach(([key, values]) => {
    values.forEach((value) => headers.append(key, value))
  })

  const res = await fetch(uploadUrl, { method: 'PUT', headers, body: blob })
  if (!res.ok) throw new Error(`S3 업로드 실패: ${res.status}`)
}

const uploadOne = async (
  shipperCode: string,
  fileName: string,
  contentType: string,
  resourceType: FileUploadResourceType,
  targetIds: number[],
  blob: Blob,
) => {
  const presign = await requestFileUploadPresign({ shipper: shipperCode, fileName, contentType })
  await uploadToS3(presign.data.uploadUrl, presign.data.signedHeaders, blob)
  await completeFileUpload({ shipper: shipperCode, key: presign.data.key, resourceType, targetIds })
}

interface UploadInspectionFilesArgs {
  shipperCode: string
  targetIds: number[]
  recordingBlob: Blob | null
  captures: Blob[]
}

/**
 * 저장 성공 뒤 녹화 버퍼·촬영 이미지를 순서대로 올린다(8단계, 1.0 과 같이 순차 처리).
 * 각 단계 실패는 저장 자체를 되돌리지 않는다 — 안내하고 로그만 남긴다.
 */
export const uploadInspectionFiles = async ({ shipperCode, targetIds, recordingBlob, captures }: UploadInspectionFilesArgs) => {
  if (recordingBlob) {
    try {
      const fileName = `webcam_binary_${Date.now()}_${randomSuffix()}.webm`
      await uploadOne(shipperCode, fileName, 'video/webm', 'VIDEO', targetIds, recordingBlob)
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
      scanNotice.failure(MESSAGES.uploadFailed)
    }
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const capture of captures) {
    try {
      const fileName = `capture_${Date.now()}_${randomSuffix()}.jpeg`
      // eslint-disable-next-line no-await-in-loop
      await uploadOne(shipperCode, fileName, 'image/jpeg', 'ATCH_FILE', targetIds, capture)
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
      scanNotice.failure(MESSAGES.uploadFailed)
    }
  }
}
